module.exports = __webpack_public_path__ + "img/duibi13.cfb1c0dc.png";